import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-seachtags',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './seachtags.component.html',
  styleUrls: ['./seachtags.component.scss']
})
export class SeachtagsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
